import React from 'react';
import { motion } from 'framer-motion';
export function OpeningHook() {
  return <section className="bg-cream-100 py-24 px-6 relative" data-id="element-114">
      <div className="container mx-auto max-w-3xl text-center" data-id="element-115">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.8
      }} data-id="element-116">
          <div className="w-12 h-px bg-gold-500 mx-auto mb-10" data-id="element-117"></div>

          <p className="font-serif text-2xl md:text-3xl leading-relaxed text-navy-800 mb-8" data-id="element-118">
            You are physically exhausted, but your brain won't shut off.
          </p>

          <p className="text-lg text-navy-700/80 leading-loose mb-8 font-light" data-id="element-119">
            It's 11 PM, and while the world is quiet, your heart is racing, your
            mind is auditing every conversation from the last three years, and
            you're bracing for a tomorrow you're too tired to face.
          </p>

          <p className="text-xl font-medium text-navy-900 leading-relaxed" data-id="element-120">
            This isn't a "sleep problem."{' '}
            <span className="text-gold-600 italic" data-id="element-121">
              It's a chemistry problem.
            </span>
          </p>

          <p className="text-lg text-navy-700/80 leading-loose mt-8 font-light" data-id="element-122">
            You aren't broken; you're just stuck in a biological feedback loop
            that has forgotten how to turn itself off.
          </p>

          <div className="w-12 h-px bg-gold-500 mx-auto mt-12" data-id="element-123"></div>
        </motion.div>
      </div>
    </section>;
}